/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BankStatusDtoV1SyncMode {
    FULL = 'Full',
    LIMITED = 'Limited',
    DISABLED = 'Disabled',
}